/* eslint-disable camelcase */
import { Grid } from '@mui/material';
import { useState } from 'react';

import { PLAN_TYPE } from '../../../constants/Subscriptions';
import { GeoFence } from '../../../domain/geoFence/GeoFence';
import { Project } from '../../../domain/project/Project';
import { useRetrieveOrganization } from '../../../hooks/organization/useRetrieveOrganization';
import { useRetrieveActiveProjectGeoFences } from '../../../hooks/project/useRetrieveActiveProjectGeoFences';
import { useRetrieveRightPanelInfo } from '../../../hooks/right-panel/useRetrieveRightPanelInfo';
import { useSearchVehicles } from '../../../hooks/vehicle/useSearchVehicles';
import { PlannerGeoFencesList } from './PlannerGeoFencesList';
import { PlannerGeoFencesMap } from './PlannerGeoFencesMap';
import { PlannerGeoFencesUnderGorilla } from './PlannerGeoFencesUnderGorilla';
import { PlannerGeoFenceRightPanel } from './planner-geo-fence-right-panel/PlannerGeoFenceRightPanel';

type PlannerGeoFencesProps = {
  project: Project;
};

export const PlannerGeoFences = ({ project }: PlannerGeoFencesProps) => {
  const { detailType, detailId } = useRetrieveRightPanelInfo();
  const { data: organization } = useRetrieveOrganization();
  const { data: geoFences } = useRetrieveActiveProjectGeoFences();
  const [selectedGeoFenceIds, setSelectedGeoFenceIds] = useState<string[]>([]);
  const [highlightedGeoFenceId, setHighlightedGeoFenceId] = useState<string | undefined>(undefined);
  const [isDrawingGeoFence, setIsDrawingGeoFence] = useState<boolean>(false);
  const [editingGeoFence, setEditingGeoFence] = useState<GeoFence | undefined>(undefined);

  const { data: paginatedVehicles } = useSearchVehicles({
    offset: 0,
    limit: 500,
  });

  if (!project) return null;

  if (organization?.subscription.plan === PLAN_TYPE.MONKEY) {
    return <PlannerGeoFencesUnderGorilla />;
  }

  return (
    <Grid container direction="row" wrap="nowrap" style={{ backgroundColor: `white` }}>
      <PlannerGeoFencesList
        project={project}
        geoFences={geoFences ?? []}
        selectedGeoFenceIds={selectedGeoFenceIds}
        projectVehicles={paginatedVehicles?.docs ?? []}
        isDrawing={isDrawingGeoFence || editingGeoFence !== undefined}
        setEditingGeoFence={setEditingGeoFence}
        setSelectedGeoFenceIds={setSelectedGeoFenceIds}
        setHighlightedGeoFenceId={setHighlightedGeoFenceId}
      />

      <PlannerGeoFencesMap
        project={project}
        geoFences={geoFences ?? []}
        selectedGeoFenceIds={selectedGeoFenceIds}
        highlightedGeoFenceId={highlightedGeoFenceId}
        editingGeoFence={editingGeoFence}
        setIsDrawingGeoFence={setIsDrawingGeoFence}
        setEditingGeoFence={setEditingGeoFence}
        setSelectedGeoFenceIds={setSelectedGeoFenceIds}
        setHighlightedGeoFenceId={setHighlightedGeoFenceId}
      />

      {detailType === `geoFence` ? (
        <PlannerGeoFenceRightPanel
          showEdit={!editingGeoFence || editingGeoFence!.id !== detailId}
          setEditingGeoFence={setEditingGeoFence}
        />
      ) : null}
    </Grid>
  );
};
